import { Directive, HostListener } from '@angular/core';

@Directive({
    selector: '[lokosPositiveInteger]',
    standalone: false,
})
export class PositiveIntegerDirective {
    private navigationKeys: string[] = [
        'Backspace',
        'Tab',
        'ArrowLeft',
        'ArrowRight',
        'Delete',
    ];

    @HostListener('keydown', ['$event'])
    onKeyDown(event: KeyboardEvent): void {
        if (
            this.navigationKeys.includes(event.key) ||
            (event.key >= '0' && event.key <= '9')
        ) {
            // Allow navigation and numeric keys
            return;
        } else {
            // Prevent all other keys
            event.preventDefault();
        }
    }

    @HostListener('paste', ['$event'])
    onPaste(event: ClipboardEvent): void {
        const clipboardData: DataTransfer | null = event.clipboardData;
        if (clipboardData) {
            const pastedInput: string = clipboardData.getData('text');
            if (!/^[0-9]+$/.test(pastedInput)) {
                event.preventDefault();
            }
        }
    }
}
